import { Component, OnInit, inject } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';
import { QarepaProgressBarService } from '@qarepa/common';
import { ForgotPasswordDialogForm } from './forgot-password-dialog.form';

@Component({
  selector: 'qaroni-forgot-password-dialog',
  templateUrl: './forgot-password-dialog.component.html',
  styleUrls: ['./forgot-password-dialog.component.scss'],
  standalone: false,
})
export class ForgotPasswordDialogComponent
  extends ForgotPasswordDialogForm
  implements OnInit
{
  dialogRef = inject<MatDialogRef<ForgotPasswordDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private recaptchaV3Service = inject(ReCaptchaV3Service);
  progressBar = inject(QarepaProgressBarService);

  ngOnInit(): void {
    this.subs.add(this.route.queryParamMap.subscribe(this.getQueryParamMap));
    this.subs.add(
      this.recaptchaV3Service.execute('login').subscribe(this.getToken)
    );
  }

  public onCancelClick(): void {
    this.dialogRef.close(false);
  }

  get email(): AbstractControl {
    return this.form.get('email');
  }

  get captcha(): AbstractControl {
    return this.form.get('captcha');
  }

  get validatedForm(): boolean {
    return this.dirtyValidForm && !this.submitting;
  }

  private getQueryParamMap = (queryParamMap: ParamMap): void => {
    if (queryParamMap.has('email')) {
      this.form.patchValue({ email: queryParamMap.get('email') });
    } else {
      this.router.navigate([`/auth/login`]);
    }
  };

  private getToken = (token: string): void => {
    if (token) {
      this.captcha.setValue(token);
    } else {
      this.captcha.setValue(null);
    }
  };

  public onSubmit(): void {
    if (this.validatedForm) {
      this.dialogRef.close({
        email: this.data,
        captcha: this.captcha.value,
      });
    }
  }
}
